import * as Sentry from "@sentry/react";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import "swiper/swiper-bundle.css";
import "flatpickr/dist/flatpickr.css";
import App from "./App.tsx";
import "./i18n"; // Added this line
import { AppWrapper } from "./shared/ui/common/PageMeta.tsx";
import { ThemeProvider } from "./context/ThemeProvider.tsx";
import { redactSentryEvent } from "./shared/infrastructure/telemetry/redactUrl.ts";

import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "./shared/infrastructure/api/queryClient.ts";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN as string,
  environment: import.meta.env.MODE,
  sendDefaultPii: false,
  tracesSampleRate: Number(import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE ?? 0.1),
  integrations: [Sentry.browserTracingIntegration(), Sentry.consoleLoggingIntegration()],
  _experiments: { enableLogs: true },
  // Cancel and guest join links carry credentials in their URL; nothing
  // that leaves the browser for Sentry may keep them.
  beforeSend: (event) => redactSentryEvent(event),
  beforeSendTransaction: (event) => redactSentryEvent(event),
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={<p>An unexpected error occurred.</p>}>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider>
          <AppWrapper>
            <App />
          </AppWrapper>
        </ThemeProvider>
      </QueryClientProvider>
    </Sentry.ErrorBoundary>
  </StrictMode>,
);
